import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["burger"];

  static bodyClass = "is-landing-nav-open";

  connect() {
    this.boundKeydown = this.keydown.bind(this);
    this.boundOutside = this.outside.bind(this);
  }

  disconnect() {
    this.#teardown();
    document.body.classList.remove(this.constructor.bodyClass);
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.element.classList.add("landing-nav--open");
    document.body.classList.add(this.constructor.bodyClass);
    this.burgerTarget.setAttribute("aria-expanded", "true");

    document.addEventListener("keydown", this.boundKeydown);
    // Deferred so the click that opened the sheet doesn't immediately close it.
    setTimeout(() => document.addEventListener("click", this.boundOutside));
  }

  close() {
    this.element.classList.remove("landing-nav--open");
    document.body.classList.remove(this.constructor.bodyClass);
    this.burgerTarget.setAttribute("aria-expanded", "false");
    this.#teardown();
  }p

  // Bound to the links themselves: tapping one scrolls to a section that the
  // open sheet is covering, so it has to close on the way.
  closeIfOpen() {
    if (this.isOpen) this.close();
  }

  get isOpen() {
    return this.element.classList.contains("landing-nav--open");
  }

  keydown(e) {
    if (e.key !== "Escape") return;
    this.close();
    this.burgerTarget.focus();
  }

  outside(e) {
    if (!this.element.contains(e.target)) this.close();
  }

  #teardown() {
    document.removeEventListener("keydown", this.boundKeydown);
    document.removeEventListener("click", this.boundOutside);
  }
}
